import React from "react";
import stl from "./productPackageItem.module.scss";
import { FmIcon, FmImage } from "@/ui-component";
import classnames from "classnames";
import PackageDetailClient from "./PackageDetailClient";
import { IMG_HOST } from "@/config/api";
import RxClient from "./RxClient";
import GetPriceClient from "@/src/components/GetPriceClient";
import { getPriceServer } from "@/src/utils/serverOnly";
export interface IProps {
    data: IData;
}

interface IData {
    id: number;
    status: number;
    price: number;
    isRecommend: number;
    createdAt: number;
    updatedAt: number;
    siteId: number;
    picPath: string;
    packageParseTag: string;
    statusCommonUse: number;
    packageCategoryId: number;
    virtualCostPrice: number;
    statusCommonSiteUse: number;
    devVersion: number;
    name: string;
    descriptions: string;
    displayName: string;
    packageSpeciality: string;
    packageSpecialityList: {
        id: number;
        sortOrder: number;
        transName: string;
    }[];
}

const ProductPackageItem: React.FC<IProps> = (props) => {
    const { data } = props;

    return (
        <div className={stl["product-package-item"]}>
            <div style={{ position: "relative" }}>
                <div className={stl["product-package-item-img"]}>
                    {data.picPath && (
                        <FmImage image={`${IMG_HOST()}/${data.picPath}`} />
                    )}
                </div>
                <div
                    className={classnames(
                        "default_layout",
                        stl["title-container"],
                    )}
                >
                    <div className={stl["product-package-item-title"]}>
                        {data.displayName}
                    </div>
                    <PackageDetailClient data={data}>
                        <FmIcon icon="icon--FAQ" className={stl["icon-faq"]} />
                    </PackageDetailClient>
                </div>
                <div className={stl["product-package-item-wrapper"]}>
                    <div className={stl["product-package-item-text"]}>
                        {data.descriptions}
                    </div>
                    <div className={stl["product-package-item-price"]}>
                        <span>
                            <GetPriceClient price={data.price} />
                        </span>
                        {!!data.virtualCostPrice && (
                            <>
                                {data.virtualCostPrice > data.price && (
                                    <s>
                                        <GetPriceClient
                                            price={data.virtualCostPrice}
                                        />
                                    </s>
                                )}
                            </>
                        )}
                    </div>
                </div>
                <RxClient data={data} />
            </div>
        </div>
    );
};

export default ProductPackageItem;
